import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  // styleUrls: ['./header.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateY(-100%)'}),
        animate('200ms ease-in', style({transform: 'translateY(0%)'}))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({transform: 'translateY(-100%)'}))
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit {

  user : firebase.User;
  userName : string;
  currentRoute:String;
  categoriesOpen:boolean;
  brandsOpen:boolean;
  newBrandsOpen:boolean;
  visible:boolean = false;
  navOpen:boolean = false;
  constructor(private afAuth:AngularFireAuth, private router:Router) {
    afAuth.authState.subscribe( user => this.user = user);

    router.events.subscribe(event => {
      if (event instanceof NavigationEnd ) {
        this.currentRoute = event.url;
        this.navOpen = false;
        this.scrollToTop();
      }
    });
  }

  scrollToTop(){
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
          window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
          window.clearInterval(scrollToTop);
      }
  }, 10);
  }

  getUserFirstName(user){
    if(this.user){
      return this.user.displayName.substr(0,this.user.displayName.indexOf(' '));
    }
  }

  ngOnInit() {
  }
  
   
  categories = [
    {label:'On grid system', slug:'on-grid-system'},
    {label:'Off grid system', slug:'off-grid-system'},
    {label:'Solar Panels', slug:'solar-panels'},
    {label:'Solar Inverters', slug:'solar-inverters'},
    {label:'Solar Chargers', slug:'solar-chargers'}
  ];

  brands = [
    {label:'Luminous', slug:'luminous'},
    {label:'Microtek', slug:'microtek'},
    {label:'Smarten', slug:'smarten'},
  ];
  
  toggleSearch(){
    this.visible = !this.visible;
  }

  closeSearch(){
    if( this.visible == true){
      this.visible = false;
    }    
  }

  toggleNav(){
    this.navOpen = !this.navOpen;
  }

  logout(){
    this.afAuth.auth.signOut();
    this.router.navigate(['/login']);
  }
  
}
